import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Spin from 'components/ui/Spin';
import DeviceList from './DeviceList/DeviceList';
import {
  getDevices,
  isFetching,
  fetchDevices,
  deleteDevice,
  getDevicesPagination,
} from 'store/deviceReducer';

class DeviceListContainer extends Component {
  componentDidMount() {
    this.props.fetchDevices({ is_testable: false });
  }

  render() {
    const { isFetching, devices, match, handleDelete, pagination, fetchDevices } = this.props;

    if (isFetching) {
      return <Spin />;
    } else {
      return (
        <div>
          <DeviceList
            devices={devices}
            match={match}
            onDelete={handleDelete}
            pagination={pagination}
            handlePageChange={fetchDevices}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  devices: getDevices(state),
  isFetching: isFetching(state),
  pagination: getDevicesPagination(state),
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchDevices,
    handleDelete: id => deleteDevice(id),
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(DeviceListContainer);



// WEBPACK FOOTER //
// ./src/features/device/DeviceListContainer/DeviceListContainer.js